import { render } from "./allotApplication.vue?vue&type=template&id=1c281abf"
import script from "./allotApplication.vue?vue&type=script&lang=js"
export * from "./allotApplication.vue?vue&type=script&lang=js"

import "./allotApplication.vue?vue&type=style&index=0&id=1c281abf&lang=scss"

import exportComponent from "D:\\JYC\\产品源码\\前端\\工作流引擎\\stgd.oa.mobile.h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__